/* Modules */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { DashboardModule } from './dashboard.module';

/* Components */
import { LoginComponent } from '../pages/login/login.component';
import { DashboardComponent } from '../pages/dashboard/dashboard.component';
import { ForgotPasswordComponent } from '../pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from '../pages/reset-password/reset-password.component';
import { MessageComponent } from '../shared/message/message.component';

/* Services */
import { MessagesService } from '../services/message/messages.service';

/* Routes */
export let loginRoutes: Routes = [
  {
    path: 'dashboard', component: DashboardComponent
  },
  {
    path: 'login', component: LoginComponent
  },
  {
    path: 'forgot', component: ForgotPasswordComponent
  },
  {
    path: 'auth/reset/:token', component: ResetPasswordComponent
  },
  {
    path: '', redirectTo: 'login', pathMatch: 'full'
  },
  {
    path: '**', component: LoginComponent
  }
];

@NgModule({
  declarations: [
    LoginComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    DashboardComponent,
    MessageComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forRoot(loginRoutes),
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    DashboardModule
  ],
  providers: [],
  exports: [LoginComponent, RouterModule, ReactiveFormsModule]
})
export class LoginModule { }
